import React, {useEffect, useState} from 'react';
import clsx from "clsx";

import useDataSource from "../../../hooks/useDataSource";
import {
    getFieldValue
} from "../../../utilities/DataSourceUtilities";

import { styled, Typography } from '@mui/material';

const PREFIX = 'EyeFrame';

const classes = {
    root: `${PREFIX}-root`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('iframe')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        width: '100%',
        height: '100%',
        margin: '0px',
        padding: '0px',
        borderRadius: '5px'
    }
}));

export default function EyeFrame({ configuration }) {


    const src = configuration.dataSource.src;
    const dataSourceName = configuration.dataSource.name;
    const keyField = configuration.dataSource.keyField;

    // App State
    const dataSource = useDataSource(dataSourceName);

    // Component State
    const [url, setUrl] = useState(null);
    const [valid, setValid] = useState(true);

    useEffect(() => {
        if (dataSource.data) {
            if (dataSource.data.length === 1) {

                const proposedUrl = src.format(getFieldValue(dataSource, keyField));

                // TODO: Make validation an option
                var request = new XMLHttpRequest();
                request.open('GET', proposedUrl, true);
                request.onreadystatechange = function(){
                    if (request.readyState === 4){
                        if (request.status === 404 && request.responseText.indexOf('404') >= 0) {
                            setValid(false);
                        } else {
                            setValid(true);
                            setUrl(proposedUrl);
                        }
                    }
                };
                request.send();


            } else {
                // Remove Key from URL
                setUrl(src.split("{0}").join(""));
            }
        }
    }, [dataSource.data]);

    return (
        <React.Fragment>
            {valid && url &&
            <Root className={classes.root} frameBorder={"0"} src={url} align={"center"} style={{color: 'grey'}}>
            </Root>
            }
            { valid === false &&
                <div>TODO: Generic Message Component</div>
            }
        </React.Fragment>
    );
}
